export const SESSION_INACTIVITY_LIMIT_MS = 60 * 60 * 1000
export const SESSION_ACTIVITY_PERSIST_INTERVAL_MS = 1000
export const SESSION_ACTIVITY_STORAGE_KEY = 'suite.v8.auth.lastActivityAt'
export const SESSION_INACTIVITY_EXPIRED_KEY = 'suite.v8.auth.inactivityExpiredAt'
export const SESSION_TIMEOUT_NOTICE_KEY = 'suite.v8.auth.timeoutNotice'
export const SESSION_TIMEOUT_NOTICE = 'Sua sessão expirou após 60 minutos sem atividade. Entre novamente para continuar.'

export function parseActivityTimestamp(value: string | null): number | null {
  if (!value) return null
  const timestamp = Number(value)
  return Number.isFinite(timestamp) && timestamp > 0 ? timestamp : null
}

export function inactivityElapsedMs(lastActivityAt: number, now = Date.now()) {
  return Math.max(0, now - lastActivityAt)
}

export function inactivityRemainingMs(lastActivityAt: number, now = Date.now()) {
  return Math.max(0, SESSION_INACTIVITY_LIMIT_MS - inactivityElapsedMs(lastActivityAt, now))
}

export function hasSessionTimedOut(lastActivityAt: number, now = Date.now()) {
  return inactivityElapsedMs(lastActivityAt, now) >= SESSION_INACTIVITY_LIMIT_MS
}
